import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  employmentDetailsFromOne,
  employmentDetailsFromTwo,
  employmentDetailsFromThree,
  employmentDetailsFromFour,
} from "app/utils/types";

interface StepsDataTypes {
  formOne?: employmentDetailsFromOne;
  formTwo?: employmentDetailsFromTwo;
  formThree?: employmentDetailsFromThree;
  formFour?: employmentDetailsFromFour;
}

interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 1,
  stepsData: {},
};
export const employmentDetails = createSlice({
  name: "employmentDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
    resetStepsData: (state) => {
      state.stepsData = {};
      state.currentStep = 1;
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData, resetStepsData } =
  employmentDetails.actions;

export default employmentDetails.reducer;
